import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet-view_right",
  "use": "icon-sheet-view_right-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-sheet-view_right\"><g><path d=\"M12 12.4V7.6a.5.5 0 01.777-.415l3.599 2.399a.5.5 0 010 .832l-3.599 2.4a.5.5 0 01-.777-.417z\" /><path stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\" d=\"M13 10H3.542\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol